import type { IActivityRequirementStatus } from "@medoma/models/activities";

export const getBackground = (state: IActivityRequirementStatus) => {
  switch (state) {
    case "unfulfilled":
      return "none";
    case "assigned":
      return "solid";
    case "unassigned":
      return "none";
    case "neutral":
      return "solid";
    default:
      throw state satisfies never;
  }
};

export const getBorder = (state: IActivityRequirementStatus) => {
  switch (state) {
    case "unfulfilled":
      return "dashed";
    case "assigned":
      return "none";
    case "unassigned":
      return "dashed";
    case "neutral":
      return "none";
    default:
      throw state satisfies never;
  }
};
